/* Custom script for Disneyland Paris brand v2.0.0 */
/* Includes all devices (mobile/desktop) */
/* Author: Lindsay Prahalad/Tom Nelson, October 2015 */

// -------------------------------------------------------------------------------------------------------------------

// Global variables

// Setup brand variable
var brand = 'dlp'


var selectedSlots = {} //contains all user selected slots, with the date and type as object key, like "2022-07-08~Lunch"
var includedSlots = []; //the extra codes of the slots included as free in the offer
var askContinueWithoutIncluded = true;
var diningModalAlreadyShown = false;
var breakfastIncludedModalAlreadyShown = false;
var characterMealDiscountedModalAlreadyShown = false;
// -------------------------------------------------------------------------------------------------------------------

// Modal dialogs

// Intermission

// Set character/nickname/fact
function intermissionData() {
    // Set random character
    var randomise = Math.floor(Math.random() * 7);
    character = [
        'jiminy-cricket',
        'cheshire-cat',
        'daisy-duck',
        'goofy',
        'mickey-mouse',
        'huey-dewey-louie',
        'minnie-mouse',
    ][randomise];

    nickname = literal('dlp.nicknames[' + randomise + ']');

    // Set random fact
    var randomise = Math.floor(Math.random() * 10);
    fact = literal('dlp.facts[' + randomise + ']');
}

// -------------------------------------------

// Display verification overlay for ticket opt-out; user can dismiss
function infants() {
    //$.removeCookie('infants'); // Development only
    // Get form
    var form = $('#form');
    // Bind new listener to 'Continue' button; record action, delay form submission by 0.25 seconds to allow GAQ to fire
    $('#infants .button').bind('click', function () {
        // Track acceptance in GA
        GA.sendEvent( 'Alert', 'Infants on Eurostar', 'Accept');
        // Set cookie to only show once per session after user accepts
        setCookie('infants', 'true', 0)
        // Submit
        setTimeout(function () { form.submit(); }, 250);
    });
    // Have we already show this advisory message?
    if (readCookie('infants') != 'true') {
        // Dialog is dismissable
        dismissable = true;
        $('#dialog').addClass('dismissable');
        // Set class
        $('#dialog').addClass('warning has-buttons');
        // Track view in GA
        GA.sendEvent( 'Alert', 'Infants on Eurostar', 'Advisory');
        // Show dialog
        modal('#infants', false);
    }
        // Otherwise continue form submission
    else { form.submit(); }
}

// -------------------------------------------------------------------------------------------------------------------

// Display overlay for Villages Nature
function villagesnature() {
    // Dialog is dismissable
    dismissable = true;
    $('#dialog').addClass('dismissable');
    // Track in GA
    GA.sendEvent( 'Book', 'Enquiry', 'Villages Nature');
    // Add class to dialog
    $('#dialog').addClass('villagesnature has-image');
    // Show dialog
    modal('#villagesnature', false);
}

// -------------------------------------------------------------------------------------------------------------------

// Display overlay for themed offline deals
function offlineDeal() {
    // Dialog is dismissable
    dismissable = true;
    $('#dialog').addClass('dismissable');
    // Track in GA
    GA.sendEvent( 'Book', 'Enquiry', 'Offline Deal');
    // Add class to dialog
    $('#dialog').addClass('offline-cta has-image');
    // Show dialog
    modal('#offline-cta', false);
}

// -------------------------------------------------------------------------------------------------------------------

// Transport switch

// Display transport options; user can dismiss
function switcher(transport) {
    // Set switch value
    $('#modify #switch').val(transport);
    // If Hotel Only then submit form
    if (transport == 'Hotel') {
        $('#form').submit();
    }
        // Otherwise show transport modal
    else {
        // Dialog is dismissable
        dismissable = true;
        $('#dialog').addClass('dismissable');
        // Set class
        $('#dialog').addClass('warning has-buttons form');
        // Setup transport
        $('#modify .switcher').hide();
        $('#' + transport.toLowerCase()).show();
        // Show dialog
        modal('#modify', false);
    }
}

// Display overlay for on request rooms that can only be booked via the call centre; user can disimss
function request() {
    // Dialog is dismissable
    dismissable = true;
    $('#dialog').addClass('dismissable');
    // Track in GA
    GA.sendEvent( 'Book', 'Enquiry', 'Request Room');
    // Add request class to dialog
    $('#dialog').addClass('request has-image');
    // Show dialog
    modal('#request', false);
}

// Submit interstitial after image has loaded
function interstitial() {
    // Dialog is not dismissable
    dismissable = false;
    // Set body to position:fixed to force toolbars
    fixBody(true);
    // Get form action
    var url = $('form').attr('action');
    // set timeout to redirect to target page following image load
    setTimeout(function () { window.location.replace(url); }, 3000);

}

// Compare form parameters with existing search
function compare(type, data) {
    var existing = $('#' + type + '-search').val().toString();
    var parameters = data.split(',');
    var current = ''; for (var i = 0; i < parameters.length; i++) { current += $('#' + type + '-' + parameters[i]).val().toString() + ','; }; current = current.replace(/,+$/, '');
    if (existing != current) { return true; } else { return false; }
}

// Switching transport options
$('#form').submit(function (event) {
    
    if (!includedSlots.length && typeof isExtraPlusPlan !== 'undefined' && isExtraPlusPlan && askContinueWithoutIncluded && $('[data-included-extra]').length ) {
        confirmContinueWithoutIncludedSelectionModal();
        return false;
    }
    if (!includedSlots.length && typeof isFullBoardPremiumPlan !== 'undefined' && isFullBoardPremiumPlan && askContinueWithoutIncluded && $('[data-included-extra]').length && dinePlanAvailableToggle) {
        confirmContinueWithoutRoyalIncludedSelectionModal();
        return false;
    }

    // Switcher only
    if ($('#modify').length) {
        // Prevent DOM from unloading before we have fired the tracking code
        event.preventDefault();
        // Set this form to be a variable
        form = this;
        // Get transport method
        var type = $('#switch').val().toLowerCase();
        // Track query type via Google Analytics and check if the search fingerprint has changed
        var query;
        var from = 'from-' + $('#current').val();
        var to = 'to-';
        var fingerprint = false;
        switch (type) {
            case 'eurostar': query = 'Eurostar + Hotel'; to += 'eurostar'; fingerprint = compare('eurostar', 'station,departure,return'); break;
            case 'flights': query = 'Flights + Hotel'; to += 'flights'; fingerprint = compare('flights', 'airport'); break;
            case 'selfdrive': query = 'Self Drive + Hotel'; to += 'selfdrive'; fingerprint = compare('selfdrive', 'vehicle,departure,return'); break;
            case 'hotel': query = 'Hotel Only'; to += 'hotel'; break;
        }
        // Add the call to the _gaq queue
        GA.sendEvent( 'Book', 'Switch', query);
        // Add virtual pageview to enable funnel reporting
        _gaq.push(['_trackPageview', '/disneyland-paris/book/switch/' + from + '/' + to + '/']);
        // Artificial 2s delay for existing search, otherwise set delay to 0.5s
        if (fingerprint) { delay = 500 } else { delay = 2000 };
        // Reset modal
        collapse();
        // Show intermission
        intermission();
        // Submit form
        submitForm();
    };
});

// -------------------------------------------------------------------------------------------------------------------

// Bookflow

// Google Analytics: track new searches with virtual pageview for funnel reporting
$('#itinerary a, #parameters a').click(function (event) { event.preventDefault(); _gaq.push(['_trackPageview', '/disneyland-paris/book/new-search/']); var href = $(this).attr('href'); setTimeout(function () { window.location = href; }, 250); });

// Select hotel; transport switch
$('.switch .options a').click(function (event) { event.preventDefault(); $(this).toggleClass('open'); $(this).closest('.switch').find('.transport').slideToggle(); });
$('.switch .inactive a').click(function () {
    if ($(this).attr('data-warning')) {
        var message = $(this).attr('data-warning').split('|');
        warning(message[0], message[1]);
    }
});
$('.switch .active a').click(function (event) { event.preventDefault(); switcher($(this).attr('data-holiday')); });

// Select Eurostar
$('#eurostar .eurostar input').change(function () {
    // Change package price
    $('.price .cost span').text($('input:radio:checked').attr('data-price'));
})
// Prompt user to acknowledge children under 4 sit on a parent's lap
$('#eurostar .outbound.infants input').click(function (event) { event.preventDefault(); infants(); })
// Class
$('#eurostar .included a').click(showDataAttributeWarning);
// Indirect
$('#eurostar .journey a').click(function (event) { event.preventDefault(); warning(literal('eurostar-indirect-title'),literal('eurostar-indirect-message') ); });

// Select flights
$('.flight.goldmedal input').click(function (event) {
    event.preventDefault();
    intermission();
    var flight = $('<input/>', { type: 'hidden', name: 'flight', value: $(this).attr('name') }); flight.appendTo($(this));
    delay = 500;
    form = $('#form');
    submitForm();
});

// Luggage
$('#luggage select[name="ebg1"]').change(function () {
    // Get values
    var bag = parseFloat($('.baggage').attr('data-price'));
    var total = parseInt($(this).val());
    // Get price; force 2 decimal places, in case of XX.00 total
    var price = (bag * total).toFixed(2)
    // Set price (format varies on mobile/desktop)
    if (mobile) {
        $('.price .cost span').text(price);
    } else if (desktop) {
        $('.price .pounds').text(price.split('.')[0]);
        $('.price .pence').text(price.split('.')[1]);
    }
})

// Select transport
$('#action.return input').click(function (event) {
    event.preventDefault();
    intermission();
    delay = 500;
    form = $('#form');
    submitForm();
});

$('#DPOF').change(function() {
    if (this.checked) {
        confirmDisneyPlusFunction();
    }
});

// Select extras
$('#extras .dates .options a').click(function (event) { event.preventDefault(); $(this).toggleClass('open'); $(this).closest('.dates').find('.sittings').slideToggle(); });

//Ensure one seating per character meal experience, per trip
function disableUncheckedCharacterMeal(element) {
    var checkedValue = $(element).prop('checked');
    var checkId = $(element).prop('id');
    var wrap;
    if (mobile) { wrap = 'div'; } else { wrap = 'table'; }
    // disable checkboxes for the same experience
    $(element).closest(wrap).find('input[data-premium = "True"]').each(function () {
        if (checkId != $(this).prop('id')) {
            $(this).prop('disabled', checkedValue)
        }
    });
}

$('#extras input[data-premium = "True"]').change(function (event) {
    disableUncheckedCharacterMeal($(this));
});


function showNoIncludedSelectedModal() {
    dismissable = true;
    $('#dialog').addClass('dismissable');
    $('#dialog').addClass('warning has-buttons');
    modal('#no-included-warning', false);
}

function ensureMealSelectionsPreserved() {
    $('[data-meal-date-and-type] input[type="checkbox"] ').each(function(i, checkbox) {
        if ($(checkbox).attr('checked') === 'checked' ) {
            disableOrEnableSlots($(this).parent());
            if ($(checkbox).parent().attr('data-included-extra')) {
                addOrRemoveFromIncludedList( $(this).parent().prev(), false);
            }
        }
    })
}

function getSelectionDateAttributes(str) {
    var attributes = str.split("~");
    
    return { date: attributes[0], type: attributes[1], restaurant: attributes[2] };
}

function disableOrEnableSlots(clickedSlot) {
    var dayContainer = $(clickedSlot).closest('[data-meal-date-and-type]');
    if (!dayContainer.attr('data-meal-date-and-type')) {
        return false;
    }
    var dataAttributes = getSelectionDateAttributes(dayContainer.attr('data-meal-date-and-type'));
    var dateAndType = dataAttributes.date + "~" + dataAttributes.type;
    var checkbox = $('input', $(clickedSlot).parent());
    var slotValue = $(checkbox).val();
    var spanSelector = '[data-meal-date-and-type^= "'+dateAndType+'"] > * ';
    var slotForSameDateAndType = selectedSlots[dateAndType];
    
    if (slotForSameDateAndType) {  //If there is already a selection for this date and type
        if (slotForSameDateAndType.slot !== slotValue) {  //If the clicked one is not the selected one, user not allowed to select more than one so show warning 
            warning(literal('character-dining-meal-already-selected-title'), literal('character-dining-meal-already-selected-message', {
                restaurant: slotForSameDateAndType.attributes.restaurant,
                type: slotForSameDateAndType.attributes.type.toLowerCase(),
                previousDate: moment(slotForSameDateAndType.attributes.date).format('dddd Do MMMM'),
            }))
            $(checkbox).attr('checked',false);

        } else { //Else, the clicked one is the selected one, so user is deselecting
            $(spanSelector ).each( function(i, slot) {
                $(slot).removeClass('slot-unavailable')
            } )
            selectedSlots[dateAndType] = false;
        }
    } else { // If there isn't a selection for this date and type, select and disable the rest of slots
        $(spanSelector).each( function(i, slot) {
            $(slot).addClass('slot-unavailable')
        } )
        $(clickedSlot).parent().removeClass('slot-unavailable')
        selectedSlots[dateAndType] = {slot: slotValue, attributes: dataAttributes } ;
    }
}

function addOrRemoveFromIncludedList(slot, showWarning) {
    var checkboxes = $('input', $(slot).parent());
    var fullPriceCheckbox = checkboxes[0];
    var includedCheckbox = checkboxes[1];
    const hasIncludedAllowanceLeft = includedAllowance() > includedSlots.length ;
    var dayContainer = $(slot).closest('[data-meal-date-and-type]');
    var dataAttributes = getSelectionDateAttributes(dayContainer.attr('data-meal-date-and-type'));
    //includedSlots stores the value of the input in the slots currently selected as included in the offer
    if (includedSlots.includes($(fullPriceCheckbox).val())) { //if the clicked checkbox was already included
        includedSlots = includedSlots.filter( slot => slot !== $(fullPriceCheckbox).val() ); //remove it from included list
    } else if ( ($(fullPriceCheckbox).attr('checked') || $(includedCheckbox).attr('checked'))) {
        if (hasIncludedAllowanceLeft) {
            includedSlots.push($(fullPriceCheckbox).val());
            //if there wasn't a included one already  show the message with the great news
            //showWarning will be false when the selections are rendered after the user clicks back, we don't need to show the message then
            if (showWarning) {
                if (isHalfBoardPremiumPlan) {
                    if (dinePlanAvailableToggle) {
                        warning(literal('character-dining-royal-included-title'), literal('character-dining-royal-included-message'));
                    } else {
                        warning(literal('character-dining-premium-included-title'), literal('character-dining-premium-included-message', { type: 'Half' }));
                    }
                } else if (isExtraPlusPlan && !diningModalAlreadyShown) {
                    warning(literal('character-dining-plus-included-title'), literal('character-dining-plus-included-message'));
                    //diningModalAlreadyShown = true;
                }
            }
        } else {
            if (isExtraPlusPlan) {
                warning(literal('character-dining-meal-discounted-title'), literal('character-dining-meal-discounted-message', {
                    type: dataAttributes.type.toLowerCase(),
                    restaurant: dataAttributes.restaurant
                }))
            }
        }
    }
    showIncludedOrFullPrice();
}

$('#extras > * input').change(function (event) {
    var hasCharacterMealsDiscounted = isPlusPlan || isStandardPlan;
    var hasBreakfastIncluded = isBreakfastOnlyPlan || isExtraPlusPlan || isPlusPlan || isStandardPlan || isFullBoardPremiumPlan || isHalfBoardPremiumPlan;
    var dayContainer = $(this).closest('[data-meal-date-and-type]');
    var dataAttributes = getSelectionDateAttributes(dayContainer.attr('data-meal-date-and-type'));
    var parentSpan = $(this.parentNode);
    if (event.currentTarget.checked && dataAttributes.type === 'Breakfast' && hasBreakfastIncluded && !breakfastIncludedModalAlreadyShown) {
        if (dinePlanAvailableToggle) {
            warning(literal('character-dining-breakfast-discounted-title'),literal('character-dining-breakfast-discounted-message',{type:dataAttributes.type.toLowerCase(), restaurant: dataAttributes.restaurant}))
        } else {
            warning(literal('character-dining-meal-discounted-title'),literal('character-dining-meal-discounted-message',{type:dataAttributes.type.toLowerCase(), restaurant: dataAttributes.restaurant}));
        }//breakfastIncludedModalAlreadyShown = true;
    }
    if (event.currentTarget.checked && dataAttributes.type !== 'Breakfast') {
        if (!characterMealDiscountedModalAlreadyShown && hasCharacterMealsDiscounted) {
            warning(literal('character-dining-meal-discounted-title'),literal('character-dining-meal-discounted-message',{type:dataAttributes.type.toLowerCase(), restaurant: dataAttributes.restaurant}))
            //characterMealDiscountedModalAlreadyShown = true;
        }
        if (isFullBoardPremiumPlan ) {
            if (dinePlanAvailableToggle) {
                warning(literal('character-dining-royal-included-title'), literal('character-dining-royal-included-message'));
            } else {
                warning(literal('character-dining-premium-included-title'), literal('character-dining-premium-included-message', {type: 'Full'}));
            }
        }
    }

    disableOrEnableSlots(parentSpan);
    if (parentSpan.attr('data-included-extra') || parentSpan.attr('data-paid-extra') ) {
        addOrRemoveFromIncludedList(parentSpan, true);
    }
});

//Pop up a message whan trying to book more then one seating per character meal experience, per trip
$('#extras label').click(function () {
    var labelId = $(this).attr('for');
    //search for premium meal plan disabled extra
    if ($('#extras input[data-premium = "True"][id="' + labelId + '"]').prop('disabled')) {
        var overrideMessage = $(this).closest('.extra').attr('data-override-alert-message');
        var overrideMessageHeader = $(this).closest('.extra').attr('data-override-alert-header');
        if (overrideMessage !== undefined || overrideMessageHeader !== undefined) {
            warning($(this).closest('.extra').attr('data-override-alert-header'), overrideMessage);
        } else {
            var diningPhone = $('#extra-container').attr('data-dining-phone');
            warning(literal('meal-prebook-title'), literal('meal-prebook-message', { diningPhone: diningPhone }) );
        }
    }
});

//Ensure Character Meal Selections Preserved
function ensureCharacterMealSelectionsPreserved() {
    var checkedIds = [];
    if (mobile) { wrap = 'ul'; } else { wrap = 'tr'; }
    //Check if there is checked chararte meal
    $('input[data-premium = "True"]').each(function () {
        if ($(this).prop('checked')) {
            disableUncheckedCharacterMeal($('input[id="' + $(this).prop('id') + '"]'));
        }
    });
}

// Select room
if ($('.room').length) {
    // Check action on room select
    $('#page input[type="submit"], #page input[type="button"]').click(function (event) {
        // Check if room is 'on request' and prevent form submission
        if (($(this).attr('data-request') == 'true') || ($('input:radio:checked').attr('data-request') == 'true')) { event.preventDefault(); request(); }
    })
}

$('#extras .extra input[name="scp"], #extras .extra input[name="smps"]').change(function (event) {
    if ($(this).is(":checked")) { // disable+hide PhotoPass+
        $("#PHPP").prop("checked", false);
        $("#PHPP").prop("disabled", true);
        $("#chkFor_PHPP").hide();
        $("#inclWithSigPackage_PHPP").show();
    }
    else {
        $("#PHPP").prop("checked", false);
        $("#PHPP").prop("disabled", false);
        $("#chkFor_PHPP").show();
        $("#inclWithSigPackage_PHPP").hide();
    }
});

// On Extras, for VNP, warn them when they tick PP or CB, that they need to coordinate their character dining with when they use their 2 park tickets
function CharacterDiningInParksNotifier()
{
    $.each($("hgroup[data-chk='true']"), function (index, value) {
        var title = $(this).attr("data-chkTitle");
        var text = $(this).attr("data-chkText");
        var parentElement = $(this);
        $.each($(this).find("input"), function (ix, val) {
            $(this).change( function() {
                if ($(parentElement).attr("data-notified") !== 'true') {
                    warning(title, text);
                    $(parentElement).attr("data-notified", "true");
                }
            });
        })
    });
}

// -------------------------------------------------------------------------------------------------------------------

// Static pages (e.g. non-bookflow)

// Planning Tools
// Track online brochure and PDF views
if($("#body.planning").length) {

	$("a.online").click(function() {
		GA.sendEvent( 'Planning Tools', 'DLP Brochure', 'View Online');
	});

	$("a.pdf").click(function() {
		GA.sendEvent( 'Planning Tools', 'Brochure PDF', 'Download');
	});
}

// Experience Enhancement Updates (mobile only)
$('#closures-table tr').click(function () { if (mobile) { $(this).toggleClass('show-attractions open'); }; });

// Themed modal
$('#themed-modal .launch').click(function (event) { event.preventDefault(); offlineDeal(); });


// On ready
$(document).ready(function () {

    // Add popup notification, if needed
    CharacterDiningInParksNotifier();

    // Interstitial
    if ($('body').hasClass('interstitial')) { interstitial(); };

    //Ensure Character Meal Selections Preserved
    if ($('#extras').length) {
        ensureCharacterMealSelectionsPreserved();
        setTimeout(ensureMealSelectionsPreserved, 1);
        setTimeout(showIncludedOrFullPrice, 1);
    }

});

function showEurostarNotAvailable(outbound, inbound) {
    if (eurostar(moment(outbound, "DD/MM/YYYY").toDate(),moment(inbound, "DD/MM/YYYY").toDate())) {
        warning(literal('search.no-trains', { noDate: outbound }), literal('search.no-train-generic'))
    }
}

function showIncludedOrFullPrice() {
    const showIncluded = includedAllowance() > includedSlots.length ;

    $('[data-meal-date-and-type]').each( (i, sittingContainer) => {
        var sittingAttributes = getSelectionDateAttributes($(sittingContainer).attr('data-meal-date-and-type'));
        var selectedType = selectedSlots[sittingAttributes.date + '~' + sittingAttributes.type];
        var hasAnySlotSelected = selectedType && selectedType.attributes.restaurant === sittingAttributes.restaurant;
        var newValue = !hasAnySlotSelected ? showIncluded : includedSlots.includes(selectedType.slot)
        $('[data-included-price="true"]', sittingContainer).toggle(newValue);
        $('[data-included-price="false"]', sittingContainer).toggle(!newValue);
        $('[data-included-extra="false"]', sittingContainer).toggle(newValue);
        $('[data-paid-extra="true"]', sittingContainer).toggle(!newValue);
    })
}

function includedAllowance() {
    if (typeof isHalfBoardPremiumPlan !== 'undefined' && isHalfBoardPremiumPlan) {
        return duration;
    } else if (typeof isFullBoardPremiumPlan !== 'undefined' && isFullBoardPremiumPlan) {
        return duration * 2;
    } else if (isExtraPlusPlan) {
        return 1;
    } else {
        return 0;
    }
}

function confirmContinueWithoutIncludedSelectionModal(){
    // Dialog is dismissable
    dismissable = true;
    $('#dialog').addClass('dismissable');
    // Set class
    $('#dialog').addClass('warning has-buttons');

    $('#continue-without-meal-selection-choose').click(function(){
        dismiss();
    })
    $('#continue-without-meal-selection-cancel').click(function(){
        askContinueWithoutIncluded = false;
        $('#form').submit();
    })
    // Show dialog
    modal('#continue-without-meal-selection', false);
}

function confirmContinueWithoutRoyalIncludedSelectionModal(){
    // Dialog is dismissable
    dismissable = true;
    $('#dialog').addClass('dismissable');
    // Set class
    $('#dialog').addClass('warning has-buttons');

    $('#continue-without-royal-meal-selection-choose').click(function(){
        dismiss();
    })
    $('#continue-without-royal-meal-selection-cancel').click(function(){
        askContinueWithoutIncluded = false;
        $('#form').submit();
    })
    // Show dialog
    modal('#continue-without-royal-meal-selection', false);
}

function confirmDisneyPlusFunction(){
    // Dialog is dismissable
    dismissable = true;
    $('#dialog').addClass('dismissable');
    // Set class
    $('#dialog').addClass('warning has-buttons');

    $('#continue-without-disneyplus').click(function(){
        $("#DPOF").prop("checked", false);
        dismiss();
    })
    $('#confirm-disney-plus').click(function(){
        $("#DPOF").prop("checked", true);
        dismiss();
    })
    // Show dialog
    modal('#disneyplus-continue-selection', false);
}
